import React, {useCallback, useMemo} from "react";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {UserLevels, UserPreferredLevel} from "../../../../containers/RegistrationLoginPage/types";
import {WithTitleField} from "../Styled";
import useLevelHandler from "../../../../hooks/useLevelHandler";
import RadioGroupWrapper from "../../../HTMLEntities/RadioGroupWrapper";

interface Props {
    configuration: UserPreferredLevel;
}
const PreferredLevel: React.FC<Props> = ({configuration}: Props) => {
    const levelCallback = useLevelHandler();
    const onChangeCallback = useCallback(
        (events: React.ChangeEvent<HTMLInputElement>) => {
            const level = events.target.value as UserLevels;
            void levelCallback({level});
        },
        [levelCallback],
    );
    return useMemo(() => {
        return (
            <>
                <WithTitleField>
                    <h3>Preferred level of study</h3>
                    <RadioGroupWrapper<UserPreferredLevel, UserLevels>
                        fieldData={configuration}
                        validate={composeValidators(
                            regRequiredValidate("Please select course level"),
                        )}
                        onChangeCallback={onChangeCallback}
                    />
                </WithTitleField>
            </>
        );
    }, [onChangeCallback, configuration]);
};
export default PreferredLevel;
